import { render, staticRenderFns } from "./proofStatus.vue?vue&type=template&id=33dd719b"
import script from "./proofStatus.vue?vue&type=script&lang=js"
export * from "./proofStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports